


















export default {
  props: ['solution', 'active'],
};

